import { render, staticRenderFns } from "./GettingStarted.vue?vue&type=template&id=40fd601d&"
import script from "./GettingStarted.vue?vue&type=script&lang=js&"
export * from "./GettingStarted.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports